import { render, staticRenderFns } from "./ParametersTable.vue?vue&type=template&id=c003127c&scoped=true&"
import script from "./ParametersTable.vue?vue&type=script&lang=js&"
export * from "./ParametersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c003127c",
  null
  
)

export default component.exports